export default __webpack_public_path__ + "static/media/diplo.220c34b3.pdf";